/* eslint-disable */
export default {
  flipHeader: 'Renvoi instantané vers…',
  flip: 'Renvoi',
  complete: 'Terminer le renvoi instantané',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
